import axios from "axios";
import Session from "./../session";

var instance = axios.create({
  baseURL: window.location.origin,
});

export default {
  namespaced: true,
  state: {
    submitting: false,
    loading: false,
    categories: [],
    products: [],
    productBundle: {},
    selectedProductBundle: {},
    selectedSmartProduct: {},
    smartTransactionData: {},
    filteredProducts: [],
    currentPage: 1,
    filter: {
      category: "0",
      searchKey: "",
    },
  },
  getters: {
    selectedProductBundle(state) {
      return state.selectedProductBundle;
    },
    selectedSmartProduct(state) {
      return state.selectedSmartProduct;
    },
  },
  mutations: {
    SET_Submitting(state, value) {
      state.submitting = value;
    },
    SET_Loading(state, value) {
      state.loading = value;
    },
    SET_Categories(state, payload) {
      state.categories = payload;
      console.log(state.categories);
    },
    SET_Products(state, payload) {
      state.products = payload;
    },
    SET_ProductBundle(state, payload) {
      state.productBundle = payload;
    },
    SET_SmartTransactionData(state, payload) {
      state.smartTransactionData = payload;
    },
    SET_CurrentPage(state, value) {
      state.currentPage = value;
    },
    FILTER_Products(state) {
      const searchKey = state.filter.searchKey.toLowerCase();

      state.filteredProducts = state.products.filter(
        (m) =>
          (m.offer || "").toLowerCase().includes(searchKey) ||
          (m.family || "").toLowerCase().includes(searchKey) ||
          (m.keyword || "").toLowerCase().includes(searchKey)
      );

      const selectedCategory = state.filter.category.toLowerCase();

      if (selectedCategory === "bundle") {
        state.filteredProducts = state.filteredProducts.filter(
          (p) => (p.brand || "").toLowerCase() === "bundle"
        );
      } else if (selectedCategory !== "0") {
        state.filteredProducts = state.filteredProducts.filter(
          (p) =>
            p.categoryCode === state.filter.category &&
            (p.brand || "").toLowerCase() !== "bundle"
        );
      }

      state.currentPage = 1;
    },
    SELECT_ProductBundle(state, payload) {
      const returnedTarget = Object.assign({}, payload);
      state.selectedProductBundle = returnedTarget;
    },

    SELECT_SmartProduct(state, payload) {
      const returnedTarget = Object.assign({}, payload);
      state.selectedSmartProduct = returnedTarget;
    },
  },
  actions: {
    GetCategories({ commit }) {
      commit("SET_Categories", []);

      return new Promise((resolve, reject) => {
        instance
          .get("api/misc/categories", {
            headers: {
              "x-public-key": "ZWxwQDIwMjI=",
            },
          })
          .then(async function (response) {
            commit("SET_Categories", response.data);
            resolve(true);
          })
          .catch(function (error) {
            reject(error.response);
          });
      });
    },
    GetProducts({ commit }) {
      commit("SET_Loading", true);
      commit("SET_Products", []);
      commit("FILTER_Products");

      return new Promise((resolve, reject) => {
        instance
          .get("api/product/all?includeNonVisible=true", {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_Loading", false);
            commit("SET_Products", response.data);
            commit("FILTER_Products");
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_Loading", false);
            reject(error.response);
          });
      });
    },
    UploadProducts({ commit }, files) {
      commit("SET_Submitting", true);
      let formData = new FormData();

      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append("files[" + i + "]", file);
      }

      return new Promise((resolve, reject) => {
        instance
          .post("api/product/batch", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_Submitting", false);
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_Submitting", false);
            reject(error.response);
          });
      });
    },
    GetProductsByBrand({ commit }) {
      commit("SET_Loading", true);
      commit("SET_Products", []);
      commit("FILTER_Products");

      return new Promise((resolve, reject) => {
        instance
          .get("api/product/all?includeNonVisible=true", {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then(async function (response) {
            commit("SET_Loading", false);
            commit("SET_Products", response.data);
            commit("FILTER_Products");
            resolve(true);
          })
          .catch(function (error) {
            commit("SET_Loading", false);
            reject(error.response);
          });
      });
    },
    CreateBundle({ commit }, bundleData) {
      commit("SET_Submitting", true);

      return new Promise((resolve, reject) => {
        instance
          .post("api/product/create/bundle", bundleData, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then((response) => {
            commit("SET_Submitting", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_Submitting", false);
            reject(error.response);
          });
      });
    },
    UpdateProductStatus({ commit }, { productID, bundleID, isVisible }) {
      commit("SET_Submitting", true);

      const params = new URLSearchParams();

      params.append("productId", productID);
      params.append("bundleId", bundleID);
      params.append("isVisible", isVisible);

      return new Promise((resolve, reject) => {
        instance
          .put(`api/product/activate?${params.toString()}`, null, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then((response) => {
            commit("SET_Submitting", false);
            resolve(response.data);
          })
          .catch((error) => {
            commit("SET_Submitting", false);
            reject(error.response);
          });
      });
    },

    GetProductBundleByID({ commit, getters }, subRetailerUserLogID) {
      commit("SET_Loading", true);
      commit("SET_ProductBundle", []);

      const bundle = getters.selectedProductBundle;

      return new Promise((resolve, reject) => {
        instance
          .get(
            `api/product/bundle/${bundle.bundleID}/${subRetailerUserLogID}`,
            {
              headers: {
                Authorization: "Bearer " + Session.token(),
              },
            }
          )
          .then((response) => {
            commit("SET_ProductBundle", response.data);
            commit("SET_Loading", false);
            resolve(true);
          })
          .catch((error) => {
            commit("SET_Loading", false);
            reject(error.response);
          });
      });
    },

    GetSmartProductByID({ commit }, { productID, subRetailerUserLogID }) {
      commit("SET_Loading", true);
      commit("SET_SmartTransactionData", []);

      return new Promise((resolve, reject) => {
        instance
          .get(`api/product/product/${productID}/${subRetailerUserLogID}`, {
            headers: {
              Authorization: "Bearer " + Session.token(),
            },
          })
          .then((response) => {
            commit("SET_SmartTransactionData", response.data);
            commit("SET_Loading", false);
            resolve(true);
          })
          .catch((error) => {
            commit("SET_Loading", false);
            reject(error.response);
          });
      });
    },
  },
};
